import React, { useState } from "react";
import "./secretShare.scss";
import CustomRadioButton from "components/CustomRadioButton";
import Input from "components/Input/index";
import SquareCheckBox from "components/SquareCheckBox/index";
import MultiSelectDropDown from "components/MultiSelectDropDown/MultiSelectDropDown";
import noData from "assets/images/homepage/PasswordManger/noResult/Nodata.png";

const SecretShare = () => {
  // This States Contain all Detail of the Secret Share Data
  const [selectedOption, setSelectedOption] = useState("users");
  const [checkedUsers, setCheckedUsers] = useState([]);
  const [Operation, setOperation] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const options = [
    { label: "Users", value: "users" },
    { label: "Teams", value: "teams" },
    { label: "Application", value: "application" }
  ];

  const users = [
    "Brooklyn Simmons",
    "Jane Cooper",
    "Bessie Cooper",
    "Devon Lane",
    "Arlene McCoy",
    "Jacob Jones"
  ];

  const teams = [
    "Design Team",
    "React Dev Team",
    "React Native Dev Team",
    "Bussines  Team",
    "Sale Team",
    "QA Team"
  ];

  const applications = [
    "Adobe suite",
    "Figma",
    "Visual Studio Code",
    "Postman",
    "GitHub",
    "Netlify"
  ];
  // This function for changing the Radio Button
  const handleChange = (e) => {
    setSelectedOption(e.target.value);
    setSearchTerm("");
    setCheckedUsers([]);
    setOperation([]);
  };

  const handleUserToggle = (item) => {
    setCheckedUsers((prev) =>
      prev.includes(item) ? prev.filter((u) => u !== item) : [...prev, item]
    );
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const getCurrentList = () => {
    if (selectedOption === "teams") return teams;
    if (selectedOption === "application") return applications;
    return users;
  };

  const currentList = getCurrentList();

  const filteredItems = currentList.filter((item) =>
    item.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="secretContainer">
      <div className="options">
        {options.map((option) => (
          <CustomRadioButton
            key={option.value}
            label={option.label}
            name="group"
            value={option.value}
            checked={selectedOption === option.value}
            handleOnchange={handleChange}
            type="radio"
          />
        ))}
      </div>

      <div className="userListData">
        <p>
          {selectedOption.charAt(0).toUpperCase() + selectedOption.slice(1)}{" "}
          list
        </p>
        <Input
          placeholder={`Search ${selectedOption}`}
          inputKey="secretPath"
          searchIconBool={true}
          value={searchTerm}
          onChange={handleSearchChange}
        />
      </div>

      <div className="userListDataContent">
        {filteredItems.length === 0 ? (
          <div className="secretNoDataFound">
            <img src={noData} alt="No Data Found" className="noDataImage" />
            <p className="noDataText">No {selectedOption} found</p>
          </div>
        ) : (
          <>
            {filteredItems.map((item, index) => (
              <label key={index} className="user-item">
                <SquareCheckBox
                  label=""
                  isChecked={checkedUsers.includes(item)}
                  isDisable={false}
                  onChange={(e) => {
                    e.stopPropagation();
                    handleUserToggle(item);
                  }}
                />
                <span className="custom-checkbox" />
                {item}
              </label>
            ))}
          </>
        )}
      </div>

      <MultiSelectDropDown
        selectedCountries={Operation}
        onSelectCountries={setOperation}
        label="Operation"
        width="93%"
        placeholder="Select operation"
      />
    </div>
  );
};

export default SecretShare;
